// Pages
import PrePozadavkyNevyrizenePage from "../pages/PrePozadavkyNevyrizenePage";
import PozadavkyNevyrizenePage from "../pages/PozadavkyNevyrizenePage";
import PozadavkyVyrizenePage from "../pages/PozadavkyVyrizenePage";
import PozadavkyOdmitnuteDokumentyPage from "../pages/PozadavkyOdmitnuteDokumentyPage";
import UkolyHistoriePage from "../pages/UkolyHistoriePage";
import UkolyNevyrizenePage from "../pages/UkolyNevyrizenePage";
import SchvaleniHistoriePage from "../pages/SchvaleniHistoriePage";
import SchvaleniNevyrizenePage from "../pages/SchvaleniNevyrizenePage";
import PozadavkyHistoriePage from "../pages/PozadavkyHistoriePage";
// Administrace
import TemplatesPage from "../pages/TemplatesPage";
import SestavyPage from "../pages/SestavyPage";
import UsersPage from "../pages/UsersPage";
import SignConfigurationsPage from "../pages/SignConfigurationsPage";
import FlowConfigurationsPage from "../pages/FlowConfigurationsPage";
import CiselnikTextuConfigPage from "../pages/TextNotesPage";
import ProstredkyPage from "../pages/ProstredkyPage";
import KombinacePage from "../pages/KombinacePage";
import VisualizationPage from "../pages/VisualizationPage";
import RedirectToDefaultPage from "../pages/RedirectToDefaultPage";

/**
 * Vrátí seznam položek menu - PŘEDBĚŽNÉ
 * @returns {Array}
 */
export const getPrePozadavkyMenuItems = (counts?: any) => {
    return [
        {
            key: "preMpNevyrizene",
            title: "Nevyřízené",
            path: `/pre/pozadavky/nevyrizene`,
            component: PrePozadavkyNevyrizenePage,
            count: counts && counts["preMpNevyrizene"],
        },
    ];
};

/**
 * Vrátí seznam položek menu - POŽADAVKY
 * @returns {Array}
 */
export const getPozadavkyMenuItems = (counts?: any) => {
  return [
    {
      key: "mpNevyrizene",
      title: "Nevyřízené",
      path: `/pozadavky/nevyrizene`,
      component: PozadavkyNevyrizenePage,
      count: counts && counts["mpNevyrizene"],
    },
    {
      key: "mpVyrizene",
      title: "Vyřízené",
      path: `/pozadavky/vyrizene`,
      component: PozadavkyVyrizenePage,
    },
    {
      key: "mpOdmDokumenty",
      title: "Odmítnuté dokumenty",
      path: `/pozadavky/odmitnute-dokumenty`,
      component: PozadavkyOdmitnuteDokumentyPage,
      count: counts && counts["mpOdmDokumenty"],
    },
    {
      key: "klickek123",
      title: "Historie",
      path: `/pozadavky/historie`,
      component: PozadavkyHistoriePage,
    },
  ];
};

/**
 * Vrátí seznam položek menu - ÚKOLY
 * @returns {Array}
 */
export const getUkolyMenuItems = (counts) => {
  return [
    {
      key: "muNevyrizene",
      title: "Nevyřízené",
      path: `/ukoly/nevyrizene`,
      component: UkolyNevyrizenePage,
      count: counts && counts["muNevyrizene"],
    },
    {
      key: "chlebaSMaslem",
      title: "Historie",
      path: `/ukoly/historie`,
      component: UkolyHistoriePage,
    },
  ];
};

/**
 * Vrátí seznam položek menu - MÁM SCHVÁLIT
 * @returns {Array}
 */
export const getSchvaleniMenuItems = (counts) => {
  return [
    {
      key: "keSchvaleniNevyrizene",
      title: "Nevyřízené",
      path: `/ukoly/schvaleniNevyrizene`,
      component: SchvaleniNevyrizenePage,
      count: counts && counts["muKeSchvaleni"],
    },
    {
      key: "keSchvaleniHistorie",
      title: "Historie",
      path: `/ukoly/schvaleniHistorie`,
      component: SchvaleniHistoriePage,
    },
  ];
};

/**
 * Vrátí seznam položek Administrace menu - NEVYŘÍZENÉ
 * @returns {Array}
 */
export const getAdminMenuItems = (isAdmin: boolean) => {
    return [
        { key: 7, title: "Šablony notifikací", path: `/administrace/sablony`, component: isAdmin ? TemplatesPage : RedirectToDefaultPage },
        { key: 8, title: "Přehled uživatelů", path: `/administrace/uzivatele`, component: isAdmin ? UsersPage : RedirectToDefaultPage },
        { key: 9, title: "Podpisové konfigurace", path: `/administrace/konfigurace`, component: isAdmin ? SignConfigurationsPage : RedirectToDefaultPage },
        { key: 14, title: "Schvalovací konfigurace", path: `/administrace/flowkonfigurace`, component: isAdmin ? FlowConfigurationsPage : RedirectToDefaultPage },
        { key: 10, title: "Sestavy a přehledy", path: `/administrace/sestavy`, component: isAdmin ? SestavyPage : RedirectToDefaultPage },
        { key: 11, title: "Prostředky", path: `/administrace/Prostredky`, component: isAdmin ? ProstredkyPage : RedirectToDefaultPage },
        { key: 12, title: "Kombinace", path: `/administrace/Kombinace`, component: isAdmin ? KombinacePage : RedirectToDefaultPage },
        { key: 13, title: "Podpis a pečeť", path: `/administrace/Vizualizace`, component: isAdmin ? VisualizationPage : RedirectToDefaultPage },
        { key: 15, title: "Číselník poznámek", path: `/administrace/ciselniktextu`, component: isAdmin ? CiselnikTextuConfigPage : RedirectToDefaultPage },
    ];
};
